/**
 * 🚨🚨🚨🚨🚨🚨🚨🚨
 * DO NOT ADD OR CHANGE THESE VALUES. THESE ARE NOT FOR ENGINEERING TO MODIFY. DO NOT REFERENCE THESE DIRECTLY WITHIN THE COMPONENTS/STYLES
 *
 * ONLY CHANGE/MODIFY THESE WITH EXPLICIT PERMISSION FROM DESIGN. THIS SHOULD ONLY HAPPEN WHEN THEY TELL US THE COLOR SCHEME IS CHANGING.
 * 🚨🚨🚨🚨🚨🚨🚨🚨
 */
// Core Colors
type WhitePalette = 'white'
type BlackPalette = 'black'
type BluePalette = 'blue100' | 'blue200' | 'blue300' | 'blue400' | 'blue500'
type GrayPalette =
  | 'gray100'
  | 'gray200'
  | 'gray300'
  | 'gray400'
  | 'gray500'
  | 'gray600'
  | 'gray700'
  | 'gray800'
  | 'gray900'
  | 'gray1000'

// Semantic Colors
type YellowPalette = 'yellow100' | 'yellow200' | 'yellow300' | 'yellow400' | 'yellow500'
type RedPalette = 'red100' | 'red200' | 'red300' | 'red400' | 'red500'
type CyanPalette = 'cyan100' | 'cyan200' | 'cyan300' | 'cyan400' | 'cyan500'
type GreenPalette = 'green100' | 'green200' | 'green300' | 'green400' | 'green500'
type OrangePalette = 'orange100' | 'orange200' | 'orange300' | 'orange400' | 'orange500'

// Secondary Colors
type CamoPalette = 'camo100' | 'camo200' | 'camo300' | 'camo400' | 'camo500'
type NeonPalette = 'neon100' | 'neon200' | 'neon300' | 'neon400' | 'neon500'
type PurplePalette = 'purple100' | 'purple200' | 'purple300' | 'purple400' | 'purple500'
type TealPalette = 'teal100' | 'teal200' | 'teal300' | 'teal400' | 'teal500'

export type ColorPalette = GrayPalette &
  YellowPalette &
  RedPalette &
  BluePalette &
  CyanPalette &
  GreenPalette &
  WhitePalette &
  BlackPalette &
  OrangePalette &
  CamoPalette &
  NeonPalette &
  PurplePalette &
  TealPalette

const whites: Record<WhitePalette, string> = {
  white: '#FFFFFF',
}

const blacks: Record<BlackPalette, string> = {
  black: '#0A0E1B',
}

const grays: Record<GrayPalette, string> = {
  gray100: '#F0F1F3',
  gray200: '#E4E5EA',
  gray300: '#C9CAD5',
  gray400: '#AEB0BC',
  gray500: '#9396A4',
  gray600: '#787C8C',
  gray700: '#606374',
  gray800: '#484A59',
  gray900: '#2F313F',
  gray1000: '#171924',
}

const yellows: Record<YellowPalette, string> = {
  yellow100: '#FFF4CC',
  yellow200: '#FFE380',
  yellow300: '#FFC900',
  yellow400: '#997719',
  yellow500: '#624800',
}

const reds: Record<RedPalette, string> = {
  red100: '#FFD3CC',
  red200: '#FF775F',
  red300: '#E61C08',
  red400: '#930F06',
  red500: '#520803',
}

const blues: Record<BluePalette, string> = {
  blue100: '#E6F0FF',
  blue200: '#99C2FF',
  blue300: '#006AFF',
  blue400: '#004080',
  blue500: '#0B1533',
}

const cyans: Record<CyanPalette, string> = {
  cyan100: '#DAF4F7',
  cyan200: '#8FDEE7',
  cyan300: '#44C8D7',
  cyan400: '#297881',
  cyan500: '#0E282B',
}

const greens: Record<GreenPalette, string> = {
  green100: '#C7F2D0',
  green200: '#5CD98E',
  green300: '#06A75F',
  green400: '#046B3F',
  green500: '#023D23',
}

const orange: Record<OrangePalette, string> = {
  orange100: '#FFE0CC',
  orange200: '#FFA04D',
  orange300: '#FB6616',
  orange400: '#B3470F',
  orange500: '#632709',
}

const camos: Record<CamoPalette, string> = {
  camo100: '#ECEAE3',
  camo200: '#D7D2C2',
  camo300: '#C3BDAF',
  camo400: '#857F72',
  camo500: '#4A473F',
}

const neons: Record<NeonPalette, string> = {
  neon100: '#F4FFC2',
  neon200: '#E5FF73',
  neon300: '#D2FF28',
  neon400: '#96B71D',
  neon500: '#4A5B0F',
}

const purples: Record<PurplePalette, string> = {
  purple100: '#DBD6F9',
  purple200: '#867AE6',
  purple300: '#2A2283',
  purple400: '#1B165A',
  purple500: '#0E0A33',
}

const teals: Record<TealPalette, string> = {
  teal100: '#CCFBF7',
  teal200: '#66F2E5',
  teal300: '#00EDD9',
  teal400: '#009C8F',
  teal500: '#00524A',
}

export const colorPalette = {
  ...whites,
  ...blacks,
  ...grays,
  ...yellows,
  ...reds,
  ...blues,
  ...cyans,
  ...greens,
  ...orange,
  ...camos,
  ...neons,
  ...purples,
  ...teals,
}
